// extracted by mini-css-extract-plugin
module.exports = {"form__inputWrapper":"Form-module--form__input-wrapper--1TE1n","form__column":"Form-module--form__column--2Ojii","form__footer":"Form-module--form__footer--2m63T"};